import axios from "axios";
// import { API_URL } from "./vars";
import VARS from "@/services/vars"


const api = axios.create({
  baseURL: VARS.API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getAdminProfile() {
  return api.get("/api/admin/profile");
}

export function getTenants() {
  return api.get("/api/admin/tenants");
}

export function createTenant(payload) {
  return api.post("/api/admin/tenants", payload);
}

export function updateTenant(id, payload) {
  return api.put(`/api/admin/tenants/${id}`, payload);
}

export function getUsers() {
  return api.get("/api/admin/users");
}

export function createUser(payload) {
  return api.post("/api/admin/users", payload);
}

export function updateUser(id, payload) {
  return api.put(`/api/admin/users/${id}`, payload);
}

export function resetUserPassword(id, payload) {
  return api.post(`/api/admin/users/${id}/reset-password`, payload);
}

export function getFlows() {
  return api.get("/api/manager/flows");
}

export function getFlow(id) {
  return api.get(`/api/manager/flows/${id}`);
}

export function createFlow(payload) {
  return api.post("/api/manager/flows", payload);
}

export function updateFlow(id, payload) {
  return api.put(`/api/manager/flows/${id}`, payload);
}